import Card from "app/components/Card";
import IconButton from "app/components/IconButton";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  selectTicketCreateLoading,
  selectTicketFormDetail,
} from "../../containers/Tickets/redux/selector";
import { actions } from "../../containers/Tickets/redux/slice";
import PrioritySelection from "./PrioritySelection";
import SelectAssignee from "./SelectAssignee";
import SelectStatus from "./SelectStatus";
import TypeSelection from "./TypeSelection";
import TagSelection from "./tag-selection";
import DueDateSection from "./duedate-section";
import { selectTicketTypes } from "app/redux/selector";
import { TicketGroup } from "../../types";
import Input from "app/components/Input";
import { attachClickOutsideListener } from "../Settings/helper";
import Fields from "./fields";

interface ColumnTaskCreateProps {
  readonly onCancel: () => void;
  readonly group: TicketGroup;
}

const ColumnTaskCreate: React.FC<ColumnTaskCreateProps> = ({
  onCancel,
  group,
}) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const params = useParams();
  const ticketTypes = useSelector(selectTicketTypes);
  const dispatch = useDispatch();
  const form = useSelector(selectTicketFormDetail);
  const loading = useSelector(selectTicketCreateLoading);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    dispatch(
      actions.setTicketFormValue({
        name: name,
        value: value,
      })
    );
  };
  const handleSelect = (name: string, value: any) => {
    dispatch(
      actions.setTicketFormValue({
        name: name,
        value: value,
      })
    );
  };

  const handleSave = () => {
    dispatch(
      actions.setCreateTicket({
        projectId: params.project as string,
        boardId: params.id as string,
        groupId: group?._id,
        callback() {
          onCancel();
        },
      })
    );
  };
  const [isDropdownOpen, setIsDropdownOpen] = React.useState(false);
  React.useEffect(() => {
    const cleanup = attachClickOutsideListener(ref, () => {
      if (isDropdownOpen) {
        setIsDropdownOpen(false);
        return;
      }

      if (!form?.title || form?.title.length === 0) {
        onCancel();
      }
    });

    return cleanup;
  }, [form?.title, isDropdownOpen]);
  return (
    <React.Fragment>
      <Card
        ref={ref}
        className={`mt-[16px] cursor-pointer hover:border border-secondary relative rounded-[6px] ps-[10px] pr-[8px] py-[12px]    `}
      >
        <div className="flex flex-col gap-1">
          <div className="flex flex-row gap-[4px] group relative items-center justify-between">
            <div className="flex items-center gap-[4px] ">
              <div className="w-[85%] ">
                <Input
                  type="text"
                  id="title"
                  name="title"
                  value={form?.title}
                  onChange={(e) => handleChange(e)}
                  className="w-full text-sm leading-[21px] font-medium focus:outline-none"
                  inputClassName="!h-[20px] px-[6px]"
                  placeholder={`Enter ${ticketTypes
                    ?.find((x) => x?._id === form?.type)
                    ?.name?.toLowerCase()} name`}
                  autoFocus
                  noBorder
                />
              </div>
            </div>
            {form?.title?.length > 0 && (
              <IconButton
                className="border-0"
                onClick={() => handleSave()}
                loading={loading}
              />
            )}
          </div>
          <Fields
            onOpen={() => setIsDropdownOpen(true)}
            onClose={() => setIsDropdownOpen(false)}
            form={form}
            handleSelect={handleSelect}
            group={group}
          />
        </div>
      </Card>
    </React.Fragment>
  );
};

export default ColumnTaskCreate;
